var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"local-loading"}},[_c('div',{staticClass:"local-loading-overlay"},[_c('img',{staticClass:"local-loading-img",attrs:{"src":"images/loading-load.gif"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }